/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  message,
  Modal,
  Popover,
  Radio,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "../UserList.css";
import {
  CaretDownOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  OneToOneOutlined,
  PlusOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  SwitcherOutlined,
} from "@ant-design/icons";
import MainTable from "./component/MainTable";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";

export default function UserList() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [delList, setDelList] = useState([]);
  const [loading, setLoading] = useState(true);
  const childRef = useRef(); // 创建一个 ref 来引用子组件实例
  const completedByRef = useRef(null);

  const [tableHead, setTableHead] = useState({
    status: "completed",
    completedRemark: null,
    completedByName: null,
    remark: null,
    assignedToName: null,
    propUnit: null,
    unitStatus: null,
    propType: null,
    units: null,
    unitStatus: null,
    sCompletedTime: null,
    eCompletedTime: null,
    city: null,
  });

  // 定义父组件方法，用于更新父组件的状态

  const deleteNum = (num) => {
    console.log(num);
    setDelList(num);
  };
  //调用子组件showModal方法
  // const showModal = () => {
  //   if (childRef.current) {
  //     // childRef.current.showModal();
  //   }
  // };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };
  const showModalTwo = () => {
    console.log("==========childRef.current============");
    console.log(childRef.current);
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };
  //fetchData(1, 25);
  //删除接口
  const delfun = async (data) => {
    console.log(data);
    const storedUser = localStorage.getItem("user"); //获取用户信息
    const userObject = JSON.parse(storedUser); // 转换回对象
    console.log(userObject);
    const delData = {
      ids: data,
      userId: localStorage.getItem("accountId"),
    };
    console.log(delData);
    const response = await http.get(
      `${api.MaintenanceDel}?ids=${data}&userId=${localStorage.getItem(
        "accountId"
      )}`
    );
    console.log(response);
    message.success("Successfully Deleted");
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };
  //  下载
  const DownloadBtn = () => {
    Modal.confirm({
      title: "You are exporting Data based on Completed DateRange. Are you sure you want to download the data?",
      icon: <ExclamationCircleOutlined />,

      okText: "Sure",
      cancelText: "Cancel",
      async onOk(tableHead) {
        setLoading(true);
        try {
          if (childRef.current) {
            console.log(childRef.current);
            if (typeof childRef.current.getSearchValues === "function") {
              const inputValues = childRef.current.getSearchValues();
              console.log("Search Values:", inputValues);
              setTableHead((prev) => ({
                ...prev,
                ...inputValues,
              }));
              const queryParams = new URLSearchParams({
                status: tableHead?.status || "completed",
                completedRemark: inputValues.completedRemark || "",
                completedByName: inputValues.completedByName || "",
                remark: inputValues.remark || "",
                assignedToName: inputValues.assignedToName || "",
                propUnit: inputValues.propUnit || "",
                unitStatus: inputValues.unitStatus || "",
                propType: inputValues.propType || "",
                units: inputValues.units || "",
                unitAddress: inputValues.unitAddress || "",
                city: inputValues.city || "",
                sCompletedTime: tableHead?.sCompletedTime || "",
                eCompletedTime: tableHead?.eCompletedTime || "",
              });

              const response = await http.get(
                `${api.getToExcel}?${queryParams.toString()}`,
                {
                  responseType: "blob",
                }
              );

              if (response instanceof Blob) {
                const url = window.URL.createObjectURL(response);

                const link = document.createElement("a");
                link.href = url;

                // 获取当前日期并格式化为 MM-dd-yyyy
                const today = new Date();
                const month = String(today.getMonth() + 1).padStart(2, "0");
                const day = String(today.getDate()).padStart(2, "0");
                const year = today.getFullYear();
                const formattedDate = `${month}-${day}-${year}`;

                const filename = `NonMaintenance_History_${formattedDate}.xlsx`;
                link.setAttribute("download", filename);

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                message.success("File downloaded successfully.");
              } else {
                throw new Error(
                  "Invalid response from server: Expected a Blob"
                );
              }
            }
          }
        } catch (error) {
          console.error("Error:", error);
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };

  // 处理选项变化
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // 获取子组件的值
  const getTableHead = () => {
    const list = childRef.current.getValue();
    setColumns(list);
    const transformedList = list.map((item) => ({
      label: item.dataIndex,
      value: item.key,
    }));
    console.log("columns", columns);
    setOptions(transformedList);
    const transformedList2 = list.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };
  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    console.log("页面加载时执行");
    getTableHead();
  }, []); // 依赖数组为空，确保只在组件首次加载时执行
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div></div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c" onClick={DownloadBtn}>
              <Popover title="" trigger="click">
                <VerticalAlignBottomOutlined />
              </Popover>
            </Radio.Button> || null}
          </Radio.Group>
        </div>
      </Flex>
      <MainTable ref={childRef} deleteNum={deleteNum} ></MainTable>
    </div>
  );
}
